import { observable } from "mobx";
import { Type } from "class-transformer";
import PurchasedChargeVehicleRegistrationResponse from "./purchasedChargeVehicleRegistrationResponse";
import NotificationPreferencesResponse from "./notificationPreferencesResponse";
import RequestedChargeValidityResponse from "./requestedChargeValidityResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChargeProposedPurchaseResponse {
  @observable
  @Type(() => PurchasedChargeVehicleRegistrationResponse)
  vehicle?: PurchasedChargeVehicleRegistrationResponse;

  /**
   * Customer's email address for payment confirmations and payment instructions.
   */
  @observable
  emailAddress?: string;

  @observable
  @Type(() => NotificationPreferencesResponse)
  notificationPreferences?: NotificationPreferencesResponse;

  /**
   * Charge type ID.
   */
  @observable
  chargeTypeId?: string;

  /**
   * Vehicle fuel type ID.
   */
  @observable
  fuelTypeId?: string;

  @observable
  @Type(() => RequestedChargeValidityResponse)
  validity?: RequestedChargeValidityResponse;

  /**
   * External partner ID from whom was the charge purchase proposed.
   */
  @observable
  proposedPurchaseRequestId?: string;
}
